module.exports = __webpack_public_path__ + "static/media/canape-lit.e3283dc8.svg";